import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AssessmentPrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('adminToken');

  if (!token) {
    return <Navigate to="/admin/assessment/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AssessmentPrivateRoute;